import React from "react";
import {IonCol, IonList, IonRadio, IonRadioGroup, IonRow} from "@ionic/react";
import "../styles/deviceTable.css";

const STATUS_COLORS = {
    paired:   '#9E9E9E',
    active:   '#25BDBD',
    verified: '#4CAF50',
};

const ChargerTable = (props) => {

    const {data, onRadioChange, disabled} = props;

    return (
        <IonList>
            <IonRadioGroup onIonChange={onRadioChange} disabled={disabled}>
                {Array.isArray(data) && data.map((item, idx) => {
                    const status = item.attributes.status;
                    const isPaired = status === 'paired';
                    return (
                        <IonRow key={item.thingId || idx} className="devices-row">
                            <IonCol className="table-cell radio-button">
                                <IonRadio value={JSON.stringify({ macid: item.attributes.macId, thingId: item.thingId, serialnumber: item.attributes.serialNumber, status: status, pairedIpgMacId: item.attributes.pairedIpgMacId || null })} disabled={disabled} />
                            </IonCol>
                            <IonCol className="table-cell">
                                {item.attributes.serialNumber}
                            </IonCol>
                            <IonCol className="table-cell">
                                {item.attributes.macId}
                            </IonCol>
                            <IonCol className="table-cell" style={{ maxWidth: '100px' }}>
                                <span style={{
                                    fontSize: '11px',
                                    padding: '2px 8px',
                                    borderRadius: '10px',
                                    backgroundColor: STATUS_COLORS[status] || '#FF9800',
                                    color: 'white'
                                }}>
                                    {status}
                                </span>
                            </IonCol>
                            <IonCol className="table-cell">
                                {isPaired ? item.attributes.pairedIpgMacId : '—'}
                            </IonCol>
                        </IonRow>
                    );
                })}
            </IonRadioGroup>
        </IonList>
    );
}

export default ChargerTable;
